var _path, _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7495 10.6541C19.7495 15.634 15.7311 19.6636 10.7833 19.6636C5.83551 19.6636 1.81714 15.634 1.81714 10.6541C1.81714 5.67421 5.83551 1.64462 10.7833 1.64462C15.7311 1.64462 19.7495 5.67421 19.7495 10.6541Z",
    stroke: "white",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.604,
    y1: 9.97699,
    x2: 14.9627,
    y2: 9.97699,
    stroke: "white",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubIcon);
export default __webpack_public_path__ + "static/media/sub-icon.23068ae43e0bc60ec4b9039527b9d984.svg";
export { ForwardRef as ReactComponent };